import { Link } from "react-router-dom";
import { T, useLang } from "@/i18n";
import { LangSwitcher } from "@/components/LangSwitcher";

export default function Privacy() {
  const [lang, setLang] = useLang();
  const t = T[lang].privacy;

  return (
    <div className="bg-[#200910] text-[#faf6ef] min-h-screen font-sans py-16 px-6">
      <div className="max-w-3xl mx-auto" data-testid="privacy-page">
        <div className="flex items-center justify-between mb-10">
          <img src="/logo-trust-master.png" alt="Trust Master" className="h-10 w-auto shrink-0" style={{ aspectRatio: "485/155" }} data-testid="privacy-logo" />
          <LangSwitcher lang={lang} setLang={setLang} />
        </div>

        <span className="font-mono-lbl text-xs uppercase tracking-[0.18em] text-[#d3b870]">Trust Master SRL</span>
        <h1 className="font-display uppercase text-[clamp(28px,4vw,44px)] leading-[0.98] mt-3" data-testid="privacy-title">{t.title}</h1>
        <p className="text-sm text-[#b4939c] mt-3">{t.subtitle}</p>
        {t.note && <p className="text-xs text-[#8f6e77] mt-2 italic">{t.note}</p>}

        <div className="mt-10 space-y-8">
          {t.sections.map((s) => (
            <div key={s.h} className="border-t border-[#4d1a2a] pt-6">
              <h2 className="font-display uppercase text-lg text-[#d3b870]">{s.h}</h2>
              <p className="text-sm text-[#b4939c] mt-3 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>

        <Link to="/" data-testid="privacy-back-link"
          className="inline-block mt-12 px-6 py-3 border border-[#d3b870] text-[#d3b870] font-mono-lbl uppercase tracking-[0.14em] text-xs hover:bg-[#d3b870] hover:text-[#200910] transition-colors">
          {t.back}
        </Link>
      </div>
    </div>
  );
}
